"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@main/constants");
var domain_email_config_1 = __importDefault(require("./web/domain-email-config"));
var emailTools = {
    isEmailBlackListed: function (email) {
        var blackList = domain_email_config_1.default.blackListedDomains;
        if (blackList === undefined || blackList.length === 0) {
            return false;
        }
        var domain = email.substring(email.indexOf('@') + 1);
        var regex = new RegExp(blackList.join('|'), 'i');
        return regex.test(domain);
    },
    isEmailWhiteListed: function (email) {
        var whiteList = domain_email_config_1.default.whiteListedDomains;
        if (whiteList === undefined || whiteList.length === 0) {
            return false;
        }
        var domain = email.substring(email.indexOf('@') + 1);
        var regex = new RegExp(whiteList.join('|'), 'i');
        return regex.test(domain);
    },
    getPopularDomainFromWhiteList: function () {
        return domain_email_config_1.default.whiteListedDomains.slice(0, 3);
    },
    validteEmailRegex: function (email) {
        return constants_1.EMAIL_REGEX.test(email.toLowerCase());
    },
};
exports.default = emailTools;
